<main id="account-dashboard" class="account-dashboard">

  <app-dashboard-running-transactions *ngIf="showRunningTransactions"
    [initialTransactions]="runningTransactions"></app-dashboard-running-transactions>
  <app-dashboard-power-chart></app-dashboard-power-chart>
  <app-dashboard-transactions *ngIf="permissions?.navEvaluation"></app-dashboard-transactions>
</main>
